interface RangeFieldProps {
  label: string;
  value: number | '';
  onChange: (value: number | '') => void;
  required?: boolean;
  min?: number;
  max?: number;
  step?: number;
  error?: string;
}

export default function RangeField({
  label,
  value,
  onChange,
  required = false,
  min = 0,
  max = 100,
  step = 1,
  error,
}: RangeFieldProps) {
  const displayValue = value === '' || value === null || value === undefined ? min : value;

  return (
    <div>
      <label className="block text-xs text-gray-400 mb-1.5">
        {label}
        {required && <span className="text-red-400 ml-1">*</span>}
      </label>
      <div className="flex items-center gap-3">
        <input
          type="range"
          value={displayValue}
          onChange={(e) => onChange(Number(e.target.value))}
          min={min}
          max={max}
          step={step}
          className="flex-1 h-2 bg-[#1a1f3a] rounded-lg appearance-none cursor-pointer accent-orange-500"
        />
        <input
          type="number"
          value={value === '' || value === null || value === undefined ? '' : value}
          onChange={(e) => {
            const val = e.target.value;
            onChange(val === '' ? '' : Number(val));
          }}
          min={min}
          max={max}
          step={step}
          className={`w-20 bg-[#1a1f3a] border rounded-lg px-3 py-2 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-orange-500/50 ${
            error ? 'border-red-500/50' : 'border-[#2d1b3d]'
          }`}
        />
      </div>
      {error && <div className="text-xs text-red-400 mt-1">{error}</div>}
    </div>
  );
}



